<template>
    <div v-frag>
        <CardIeaAppMain colorCard="#2D3436" title="">
            <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                <v-btn class="mx-2" fab dark small color="success" @click="$router.go(-1)">
                    <v-icon dark>
                        mdi-keyboard-backspace
                    </v-icon>
                </v-btn>
                <br /><br />
                <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text mb-3">{{ title }}</div>
                <div v-frag>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">Materia</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(itemTableData,
                                    keyItemTableData) in materiaFaltantes" :key="keyItemTableData">
                                    <td v-if="
                                        itemTableData.aprobada == false ||
                                        itemTableData.examen_inscipcion_alumno ==
                                        null ||
                                        itemTableData.examen_inscipcion_alumno.notas
                                            .length == 0 ||
                                        itemTableData.examen_inscipcion_alumno
                                            .notas[3].nota < 4
                                    ">
                                        {{ itemTableData.catedra }}
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>

                    <br /><br />
                </div>
            </v-col>
        </CardIeaAppMain>
    </div>
</template>
<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
    name: 'Faltan',
    components: {
        CardIeaAppMain
    },
    computed: {
        user() {
            return this.$store.getters.user;
        }
    },
    data() {
        return {
            title: "Materias Que Me Faltan",
            materiaFaltantes: []
        }
    },
    methods: {
        async MateriasFaltan() {
            await this.$API
                .post({
                    url: "examenes/v2/showCursoIea",
                    data: {
                        alumno: this.user.IDStB
                    }
                })
                .then(res => {
                    let cursos = res.data;
                    let materias;

                    cursos.forEach(planestudio => {
                        console.log(planestudio.plan_de_estudio_v2.length !== 0);
                        if (planestudio.plan_de_estudio_v2.length !== 0) {
                            materias = planestudio.plan_de_estudio_v2.filter(
                                materia => materia.aprobada === false
                            );
                            if (materias.length > 0) {
                                this.materiaFaltantes = materias.reduce(
                                    (acc, el) => ({
                                        ...acc,
                                        [el.catedra]: el
                                    }),
                                    []
                                );
                            }
                        }
                    });

                    console.log(this.materiaFaltantes);
                });
        },
    },
    mounted() {
        this.MateriasFaltan()
    },
}
</script>